import { getURL, query } from '../../query';
import { trackLaunchAppEvent, upLaunchAppEvent } from '../../webx';
import { trackEvent as track } from '../../omega';
import { getNineChapterWebxParams } from '../../statistic';
import { LAUNCH_APP_COMMON_PARAMS_KEY, LAUNCH_EVENEID_TO_OMEGA_EVENTID_MAP, PRE_LOAD_IMGS } from '../constant';
import { utils } from '@didi/webx-js';
let hasLoad = false;
let launchAppBusinessParams = {};
export const setTrackParams = (params) => {
    launchAppBusinessParams = params;
};
export const preLoadImage = () => {
    if (hasLoad)
        return;
    const loadImgs = new utils.LoadImgs(PRE_LOAD_IMGS, {
        timeout: 2000,
        ignoreError: true,
        imgLoadCb: () => { hasLoad = true; }
    });
    loadImgs.start();
};
// 进端事件上报埋点
export const trackLaunchAppAction = (deeplink) => {
    const params = {
        args: {
            url: getURL(),
            deeplink,
        },
        ...getLaunchAppCommonParams()
    };
    trackLaunchAppEvent(params);
};
// 获取拉端通用参数
export const getLaunchAppCommonParams = () => {
    const urlParams = query();
    const nineChapterWebxParams = getNineChapterWebxParams();
    const params = {};
    LAUNCH_APP_COMMON_PARAMS_KEY.forEach(key => {
        params[key] = urlParams[key] || nineChapterWebxParams[key] || '';
    });
    return params;
};
// 拉端埋点
export const trackEvent = (eventId, data = {}) => {
    const launchAppCommonParams = getLaunchAppCommonParams();
    const { dchn, xpsid } = launchAppCommonParams;
    const params = {
        args: {
            event_id: eventId || '',
            page_url: window.location.href,
            dchn,
            ua: window.navigator.userAgent,
            ts: Date.now(),
            attrs: {
                ...data,
                xpsid,
                page_url: window.location.href,
            }
        },
        ...launchAppCommonParams,
    };
    try {
        upLaunchAppEvent(params);
        const omegaTrackInfo = LAUNCH_EVENEID_TO_OMEGA_EVENTID_MAP[eventId];
        if (!omegaTrackInfo)
            return;
        // 上报omega埋点
        const omegaParams = {
            ...launchAppCommonParams,
            url: window.location.href,
            ...data,
            ...launchAppBusinessParams
        };
        track(omegaTrackInfo.eventId, omegaTrackInfo.label, omegaParams);
    }
    catch (error) {
        console.log('event up failed: ', error);
    }
};
export const stopBubble = (e) => {
    //如果提供了事件对象，则这是一个非IE浏览器 
    if (e && e.stopPropagation) {
        e.stopPropagation();
    }
    else {
        window.event.cancelBubble = true;
    }
};
export const getCurrentPageParams = () => {
    const queryParams = query();
    const { prod_key, dchn, oaid, oaid_md5, imei, imei_md5, idfa, idfa_md5, product_id, scene, can_open_np } = queryParams;
    const currentPageParams = {
        current_page_prod_key: prod_key,
        current_page_dchn: dchn,
        oaid,
        oaid_md5,
        imei,
        imei_md5,
        idfa,
        idfa_md5,
        product_id,
        scene,
        can_open_np,
    };
    return currentPageParams;
};
